import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Helmet } from 'react-helmet';
import find from 'ramda/src/find';
import isEmpty from 'ramda/src/isEmpty';
import propEq from 'ramda/src/propEq';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Button from '@components/@core/AnimatedButton';
import Dropdown from '@components/@core/Dropdown';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import Rating from '@components/@core/Rating';
import AppActions from '~/actions/app';
import VendorActions from '~/actions/vendor';
import { RATING_STATUS } from '~/services/constants';
import Icon from '@components/@core/Icon';
import withNavigate from '~/hocs/withNavigate';

const previousGuide = [
    {
        image: '/images/buyer-guide/image1.png',
        title: 'Consumer Research in Digital Retailing',
    },
    {
        image: '/images/buyer-guide/image2.png',
        title: 'Intro to Desking',
    },
    {
        image: '/images/buyer-guide/image3.png',
        title: 'Intro to Employee Management Solutions',
    },
    {
        image: '/images/buyer-guide/image4.png',
        title: 'Intro to Outsourced BDC',
    },
    {
        image: '/images/buyer-guide/image5.png',
        title: 'Intro to Call Management',
    },
    {
        image: '/images/buyer-guide/image6.png',
        title: '5 Questions on Chat',
    },
    {
        image: '/images/buyer-guide/image7.png',
        title: '5 Questions on Sales CRMs',
    },
    {
        image: '/images/buyer-guide/image8.png',
        title: '5 Questions on Digital Retailing',
    },
    {
        image: '/images/buyer-guide/image9.png',
        title: '5 Questions on DMS',
    },
];

class BuyGuide extends Component {
    state = {
        vendor: null,
        rating: 0,
        recommend: 0,
        activeTab: 'company',
        productList: [],
        selectedCompany: [null],
        selectedCategory: [null],
        selectedProduct: [null],
    };

    componentDidMount() {
        this.props.getCategories();
        this.props.getCompanies({ payload: { per_page: 100 } }, false);
    }

    handleChangeRate = (e) => {
        this.setState({ rating: e });
    };

    handleAddProduct = (from) => () => {
        this.props.toggleModal({ type: 'Add Product', data: { before: { from } } });
    };

    handleChangeRecommend = (e) => {
        this.setState({ recommend: e });
    };

    handleChangeDropdown = (type) => (e) => {
        if (type === 'company') {
            const { companies } = this.props;
            const selectedDetail = find(propEq('id', e[0]), companies);
            this.setState({ selectedCompany: e, productList: selectedDetail?.products || [] });
        }
        if (type === 'category') {
            this.setState({ selectedCategory: e });
            this.props.getDetail({
                categoryId: e[0],
                payload: {},
                callback: this.handleSelectCategoryCallback,
            });
        }
        if (type === 'product') {
            this.setState({ selectedProduct: e });
        }
    };

    handleSelectCategoryCallback = (e) => {
        this.setState({ productList: e?.data });
    };

    handleOpenRateVendor = () => {
        const { activeTab, rating, recommend, selectedCategory, selectedCompany, selectedProduct } = this.state;
        this.props.toggleModal({
            type: 'Rate Vendor',
            data: {
                before: {
                    tab: activeTab,
                    company: selectedCompany[0],
                    category: selectedCategory[0],
                    product: selectedProduct[0],
                    rating,
                    recommend,
                },
            },
        });
    };

    handleTab = (tab) => {
        this.setState({ activeTab: tab });
    };

    handleCTA = () => {
        this.props.toggleModal({
            type: 'CTA',
            data: { before: { src: 'https://paperform.co/__embed.min.js', paperformId: 'oc43iepm' } },
        });
    };

    render() {
        const { rating, recommend, activeTab, productList, selectedCompany, selectedCategory, selectedProduct } = this.state;
        const { authenticated, categories, companies } = this.props;
        const { all, popular } = categories;

        const RecommendSymbol = [...Array(10)].map((item, idx) => {
            return (
                <div key={`rating-${idx}`} className={classNames(idx + 1 === recommend && 'active', 'rate-vendor-recommend-rate')}>
                    {idx + 1}
                </div>
            );
        });

        return (
            <ErrorBoundary className="buyer-guide">
                <Helmet>
                    <title>Dealership Vendor Buyers Guide | DrivingSales</title>
                    <meta name="description" content="Dealership Vendor Buyers Guide | DrivingSales" />
                </Helmet>
                <div className="d-h-start buyer-guide-sm mb-3 mt-2">
                    <Button className="btn-vendor-ratings" type="link" name="Vendor Ratings" onClick={() => this.props.navigate('/vendor-ratings/home')} />
                    <p className="dsl-m14 mb-0">
                        <Icon name="fas fa-chevron-right mx-2" size={12} color="#969faa" />
                        Buyer’s Guide
                    </p>
                </div>
                <div className="buyer-guide-dealership ">
                    <div className="buyer-guide-vendor">
                        <div className="inner-content">
                            <p className="dsl-w16">DEALEARSHIP VENDOR</p>
                            <p className="dsl-w76 text-400 mx-4 mx-md-0">BUYER’S GUIDE</p>
                            <p className="dsl-w14 text-400 mx-4 mx-md-0">Discover the Dealership Solutions to Maximize Your Success</p>
                            <Button className="d-h-center white-btn" type="medium" name="Subscribe" onClick={this.handleCTA} />
                        </div>
                    </div>
                    <div className="buyer-guide-subscribe">
                        <p className="dsl-b26 text-center">Stay informed on technology trends, “How-to” guides</p>
                        <p className="dsl-b26 text-center">and vendor CSI for your dealership</p>
                        <p className="dsl-b16 mt-3 text-center">
                            Twice per year, we publish the definitive guide for buying and maximizing dealership software. The products listed are vetted by thousands of real-time, verified dealer
                            ratings, and ranked according to actual user feedback. Our “how-to” articles are written by proven experts in each domain to give you an accurate pulse on the dealership
                            vendor market. Whether shopping for a DMS system or a small widget for your website, the Buyer’s Guide has the insight you need to make the right investment for your store.
                        </p>
                        <div className="d-flex dsl-b16 justify-content-center align-items-center">
                            <div>Dealers</div>
                            <Button className="d-h-center p-0 px-1" type="link" name="subscribe" onClick={this.handleCTA} />
                            <div>for free.</div>
                        </div>
                    </div>
                    <div className="d-h-between pb-3 flex-column flex-md-row">
                        <Image className="mx-2 mt-2 mt-0 mt-md-3" src="/images/buyer-guide/buyer-guide1.png" width="278px" height="170px" />
                        <Image className="mx-2 mt-2 mt-0 mt-md-3" src="/images/buyer-guide/buyer-guide2.png" width="278px" height="170px" />
                        <Image className="mx-2 mt-2 mt-0 mt-md-3" src="/images/buyer-guide/buyer-guide3.png" width="278px" height="170px" />
                    </div>
                </div>
                <div className="buyer-guide-insight">
                    <p className="dsl-b26 text-center">Insight to help you maximize the value</p>
                    <p className="dsl-b26 text-center">of the software you purchase:</p>
                    <p className="dsl-b16 text-center mt-3">Past issues include articles such as:</p>
                    <Row className="d-h-center inner-content m-auto">
                        {previousGuide.map((item, index) => (
                            <Col className="mb-4" xs={6} sm={4} key={`buyer-guide-${index}`}>
                                <Image src={item.image} />
                                <p className="dsl-b16 my-2 title text-400">{item.title}</p>
                            </Col>
                        ))}
                    </Row>
                    <div className="d-h-center">
                        <Button type="medium" name="Subscribe" onClick={this.handleCTA} />
                    </div>
                </div>

                <div className="rate-vendor">
                    <p className="dsl-b28 text-400 mb-4 text-center">Rate a Vendor</p>
                    <div className="rate-vendor-card shadow-sm">
                        <Tabs className="bg-white" defaultActiveKey="company" activeKey={activeTab} onSelect={this.handleTab}>
                            <Tab eventKey="company" title="By Company">
                                <Dropdown
                                    className="py-3 rate-vendor-dropdown"
                                    title="Company"
                                    width="fit-content"
                                    defaultIds={selectedCompany}
                                    data={companies}
                                    getValue={(e) => e.name}
                                    onChange={this.handleChangeDropdown('company')}
                                />
                            </Tab>
                            <Tab eventKey="category" title="By Category">
                                <Dropdown
                                    className="py-3 rate-vendor-dropdown"
                                    title="Category"
                                    width="fit-content"
                                    defaultIds={selectedCategory}
                                    data={all}
                                    getValue={(e) => e.name}
                                    onChange={this.handleChangeDropdown('category')}
                                />
                            </Tab>
                        </Tabs>
                        <Dropdown
                            className="py-3 rate-vendor-dropdown"
                            title="Product"
                            width="fit-content"
                            defaultIds={selectedProduct}
                            data={productList}
                            getValue={(e) => e.name}
                            onChange={this.handleChangeDropdown('product')}
                        />
                        <div className="d-h-start">
                            <Rating className="py-3 rate-vendor-rating" title="Star Rating" readonly={false} score={rating} size="large" fractions={2} onChange={this.handleChangeRate} />
                            {RATING_STATUS[rating.toFixed(0)] && (
                                <div className="rate-vendor-modal-status">
                                    <span className="dsl-b22">{RATING_STATUS[rating.toFixed(0)]}</span>
                                </div>
                            )}
                        </div>
                        <Rating
                            className="py-3 rate-vendor-modal-rating"
                            title="Likely to recommend?"
                            readonly={false}
                            showScore={false}
                            score={recommend}
                            size="large"
                            topRate={10}
                            empty={RecommendSymbol}
                            full={RecommendSymbol}
                            feedback={['Poor', 'Good', 'Excellent']}
                            onChange={this.handleChangeRecommend}
                        />
                        <div className="pt-3 d-h-end">
                            <Button name="Submit" onClick={this.handleOpenRateVendor} />
                        </div>
                    </div>
                    <div className="rate-vendor-bottom text-center mt-4">
                        <p className="dsl-b12 mb-2">Didn't find what you were looking for?</p>
                        <div className="d-flex dsl-b12 mb-0 rate-btn justify-content-center align-items-center">
                            <div>
                                <Button className="bold" type="link" name="Add Company" disabled={!authenticated} onClick={this.handleAddProduct('company')} />
                            </div>
                            <div>Or</div>
                            <div>
                                <Button className="bold" type="link" name="Add Product" disabled={!authenticated} onClick={this.handleAddProduct('product')} />
                            </div>
                        </div>
                    </div>
                </div>
            </ErrorBoundary>
        );
    }
}

BuyGuide.propTypes = {
    authenticated: PropTypes.bool.isRequired,
    categories: PropTypes.shape({
        all: PropTypes.array,
        popular: PropTypes.array,
    }),
    companies: PropTypes.array,
};

BuyGuide.defaultProps = {
    authenticated: false,
    categories: {
        all: [],
        popular: [],
    },
    companies: [],
};

const mapStateToProps = (state) => ({
    authenticated: !isEmpty(state.app.token),
    categories: state.vendor.categories,
    companies: state.vendor.vendorCompanies?.data,
});

const mapDispatchToProps = (dispatch) => ({
    getCompanies: (e, loading) => dispatch(VendorActions.getvendorcompaniesRequest(e, loading)),
    getCategories: () => dispatch(VendorActions.getcategoriesRequest()),
    getDetail: (e) => dispatch(VendorActions.getcategoryproductsRequest(e)),
    toggleModal: (e) => dispatch(AppActions.modalRequest(e)),
});

const BuyGuideWithNavigate = withNavigate(BuyGuide);

export default connect(mapStateToProps, mapDispatchToProps)(BuyGuideWithNavigate);
